import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { useDialog } from '@dni-hooks/useDialog'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useProductCatalog } from '../../../fp-b2b-shared/hooks/use-product-catalog'

const styles = stylex.create({
  container: {
    borderRadius: 8,
    gap: 16,
    backgroundColor: colors.white,
    paddingTop: 16,
    width: 320,
  },
  button: {
    width: '50%',
  },
  removeButton: {
    borderColor: colors.brand,
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: colors.white,
    color: colors.brand,
    width: '50%',
  },
})

export const DIALOG_CHECK_DELIVERY_CLASS = 'DIALOG_CHECK_DELIVERY_CLASS'

export const DialogDeliveryClass = () => {
  const { campaignId, platform } = useProductCatalog()
  const { resetCartValues } = useFpB2bCartService(campaignId, platform)
  const { open, closeDialog: closeDialogDeliveryClass } = useDialog(DIALOG_CHECK_DELIVERY_CLASS)

  const handleResetCartValues = () => {
    resetCartValues()
    closeDialogDeliveryClass?.()
  }

  return (
    <Dialog disablePortal open={open} onClose={closeDialogDeliveryClass}>
      <DialogContent>
        <VStack rootStyle={[styles.container]}>
          <Box display="flex" justifyContent="center">
            <Text variant="h4">無法執行本操作</Text>
          </Box>
          <Box>
            <Text variant="body" color={colors.grey800}>冷凍商品需要單獨結帳，購物車現在還有其他商品喔。</Text>
          </Box>
        </VStack>
      </DialogContent>
      <DialogActions display="flex" gap={2}>
        <Button rootStyle={[styles.removeButton]} onClick={handleResetCartValues}>移除其他商品</Button>
        <Button rootStyle={styles.button} onClick={closeDialogDeliveryClass}>確定</Button>
      </DialogActions>
    </Dialog>
  )
}
